import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-upgrade',
  templateUrl: './mobile-upgrade.component.html',
  styleUrls: ['./mobile-upgrade.component.scss']
})
export class MobileUpgradeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
